// Gates Meta Ads + Conversation credits and the "Ads" product type while Phase-1
// lands. The `ai_messages` add-on family is separate and NOT covered by this flag.
export const CHECKOUT_CREDITS_ENABLED = process.env.REACT_APP_CHECKOUT_CREDITS_ENABLED === "true";
